import { Modal, Radio, RadioGroup, Input, Alert } from "@snapchat/snap-design-system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCredentialsOverrideUrlsParams } from "../searchParams/useCredentialsOverrideUrlsParams";

export function CustomCredentialsModal({ visible, onClose }: { visible: boolean; onClose: () => void }) {
    const navigate = useNavigate();
    const { apiToken, groupId, setCredentialsOverrideUrls } = useCredentialsOverrideUrlsParams();
    const [selection, setSelection] = useState(apiToken || groupId ? "custom" : "default");
    const [apiTokenInput, setApiTokenInput] = useState(apiToken);
    const [groupIdInput, setGroupIdInput] = useState(groupId);

    const onApply = () => {
        if (selection === "default") {
            setCredentialsOverrideUrls(undefined, undefined);
        } else if (selection === "custom") {
            setCredentialsOverrideUrls(apiTokenInput, groupIdInput);
        }
        navigate(0);
    };

    return (
        <Modal onAction={onApply} onCancel={onClose} visible={visible} title="Custom Camera Kit Credentials">
            <RadioGroup onChange={setSelection} value={selection}>
                <Radio id="default" label="Use default credentials" value={"default"} />
                <Radio id="custom" label="Use custom credentials" value={"custom"} />
            </RadioGroup>
            {selection === "default" && (
                <>
                    <br />
                    <p>
                        Use the built-in <b>API Token</b> and <b>Group ID</b>s dedicated for each sample use case.
                    </p>
                </>
            )}
            {selection === "custom" && (
                <>
                    <br />
                    <p>
                        Provide your own <b>API Token</b> and <b>Group ID</b>. Once supplied, these credentials will be
                        used to load the lenses and power every sample use case, overriding the built-in credentials.
                    </p>

                    <Input label="API Token" value={apiTokenInput} onChange={setApiTokenInput}></Input>
                    <Input label="Group ID" value={groupIdInput} onChange={setGroupIdInput}></Input>
                    <br />
                    <Alert
                        message=<>
                            Some use cases use hard-coded lenses that depend on a specific API Token and Group ID pair
                            (e.g., the Keyboard use case). If you configure your own credentials, those particular
                            lenses may not be found, which can result in a page error.
                        </>
                        status="warning"
                        title="Note"
                    />
                </>
            )}
        </Modal>
    );
}
